
/*
* Settings that apply to the FV namespace.
* TODO: contains viewer specific defaults settings -- move those as necessary to the viewer settings defaults itself -- only want 'global settings here'
* */


var M = require('moment');
var Util = require('./util');
var fvChannel = require('glRadio').channel('FV');
var ErrorModule = require('./error');


require('extendJQuery');
require('jq.scrollbarwidth');


module.exports = {

    /* cached settings */

    isRunningNode: window.location.port === "3000",

    isIE7: Util.isIE7(),
    isIE8: Util.isIE8(),
    isIE: Util.isIE(),
    isChrome: Util.isChrome(),
    scrollBarWidth: $.scrollbarWidth(), // note: measured from HTML tag in case script appears before the end of document body

    DPI: $.fn.getDPI(),

    $ajax: {
        dataType: 'json',
        contentType: 'application/json', // at one point just used 'json' which stopped working; I believe this may have been set at one point to trigger setting pre-flight options for the full text widget
        crossDomain: true,   // allows, for example, server-side redirection to another domain ( over-ride only for spec req's ? ); I believe this was used at one point for JSONP requests with the full text widget
        statusCode: {
            401: function() {
                fvChannel.command('unauthorizedLogout'); // could pass in to rid dependency
            },
            //  DVBC-1709: in some environments, this is returned instead of 401 if X-Requested-With Header is present
            403: function() {
                fvChannel.command('unauthorizedLogout');
            }
        },
        // DVBC-1709: appears newer versions of jQuery send this automatically
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }

    },
    crePollInterval: 250,
    PATH_TO_API: null, //note: node, tomcat, or overwritten
    CRE_ROOT: null, /* Must be set on init -- derived from path to API */
    /* note: the default also defined in the plugin -- TODO: get from require */
    getCRERoot: function() {
        return this.CRE_ROOT;
    },

    absolutePathToES: null, //set in init (options.absolutePathToES / default); fn to retrieve in channel -- this gets set on the ES model

    fromUrlInterface: 0, // passed as true if called from URL interface
    onClick: null,

    // Return the path the the client version file.
    // Note: for node environment, run grunt copy:versionNode to copy the dummy versionDEV file into the build dir 
    // (with the same name used in PROD) ... why not using isNode here / better build setup ?
    pathToVersionFile: function() {
        return __webpack_public_path__ + this.VERSION_FILE;
    },

    /* Date-Time */
    DATE_FMT_STR: 'M/D/YYYY',
    DT_TIME_FMT_STR: 'M/D/YYYY h:mma', // 4/25/2019 5:03pm -- main format used in app (eg used for ctime in notes panel)
    DT_TIME_FMT_AMPM_SPACE_BF_CAPS_STR: 'M/D/YYYY h:mm A', // 4/25/2019 5:03 PM

    /* file system ...*/
    VERSION_FILE: 'version.json',

    NEW_WINDOW_NAMESPACE: 'FV-NEW-WINDOW', // variable name of the namespace stored on the created window when the viewer is launched through 'New Window' feature

    initialize: function( options ) { /* note: 'configurationOptions' -- if provided override the defaults (would be of install) */

        var isRunningNode = this.isRunningNode; // need to detect at runtime if want to use local file with 'prod' build pointing to the same script

        //note: logic here is a bit dicey -- can be running local files and node, external files and node; etc, ...
        /* if given, set it and the urls that derive from it (based on DEV, NODE, ... -- some now called from fn's */

        if ( options.pathToAPI ) {
            this.PATH_TO_API = Util.urlEndSlash( options.pathToAPI );
        } else {
            //defaults
            this.PATH_TO_API = isRunningNode ? (NODE_PATH_TO_API) : (TOMCAT_PATH_TO_API);
        }

        this.absolutePathToES = options && options.absolutePathToES ? options.absolutePathToES : this.PATH_TO_API + 'servers/elasticsearch';

        //TODO: have a generic extend for overrides
        options.crePollInterval && (this.crePollInterval = options.crePollInterval);
        options.fromUrlInterface && (this.fromUrlInterface = options.fromUrlInterface);
        options.onClick && (this.onClick = options.onClick);

        if (PRODUCTION)
            window.onerror = ErrorModule.onerror;

        //( api route in from of express calls )

        //TODO: put in API module (?) -- no (dependent on server running -- different format) ... could pass that too
        this.CRE_ROOT = isRunningNode
            ? this.PATH_TO_API
            : this.PATH_TO_API.replace('/api', ''); //TODO: ABOVE ...


    }

};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/settings.js
 ** module id = 74
 ** module chunks = 0
 **/